import { SelectItem } from '@models/index';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class TimeService {
    constructor(private http: HttpClient) {}

    getTimestamp(): string {
        return new Date().toISOString();
    }

    getTimeZones() {
        return this.http.get<any[]>('api/formng/timezones').subscribe(zones =>
            zones.map(tz => {
                const i = new SelectItem();
                i.label = tz.name;
                i.value = tz.id;
                return i;
            })
        );
    }

    private getUserTimezone(): string {
        const claims = JSON.parse(localStorage.getItem('id_token_claims_obj'));
        return claims?.TimeZoneId || 'UTC';
    }

    public convertToUserTimeZone(time: string | Date): string {
        const timeZone = this.getUserTimezone();
        if (timeZone === 'UTC') {
            return time.toString();
        }
        const date = new Date(time);
        const options: Intl.DateTimeFormatOptions = {
            timeZone,
            weekday: 'short',
            year: 'numeric',
            month: 'short',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
        };
        return new Intl.DateTimeFormat('en-GB', options).format(date);
    }
}
